/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { ClientConfigurationDormerSpecificSettingsClientVariableSettingsVisualizationType } from "../ClientConfigurationDormerSpecificSettingsClientVariableSettingsVisualizationType";

export class ClientConfigurationDormerSpecificSettingsClientVariableSettingsDto {
    id: string;
    visualizationType: ClientConfigurationDormerSpecificSettingsClientVariableSettingsVisualizationType;
    sizeOpeningFrameRod: number;
    sizeFramesSeparatorRod: number;
    sizeFrameSurroundingRod: number;
    offsetFrameGroupDepthNonPanel: number;
    offsetFrameGroupDepthPanel: number;
    offsetFrameDepthNonWindowVariation: number;
    offsetFrameDepthWindowVariation: number;
    drawThreeDimensional: boolean;
    drawTwoDimensionalForCustomer: boolean;
    drawTwoDimensionalForPro: boolean;
    drawTwoDimensionalLineMeasurementsForCustomer: boolean;
    showPriceAtStep: number;
}
